export default "__VITE_ASSET__Du6Hqu1v__"